import { render, staticRenderFns } from "./clothOutput.vue?vue&type=template&id=93660728&scoped=true"
import script from "./clothOutput.vue?vue&type=script&lang=js"
export * from "./clothOutput.vue?vue&type=script&lang=js"
import style0 from "./clothOutput.vue?vue&type=style&index=0&id=93660728&prod&lang=scss&scoped=true"
import style1 from "./clothOutput.vue?vue&type=style&index=1&id=93660728&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93660728",
  null
  
)

export default component.exports